import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import { FaGavel } from "react-icons/fa";
import { motion } from "framer-motion";
import { margin } from "@mui/system";
import "../Services.css"; // Assuming you have a CSS file for styles


// framer-motion variants
const containerVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 60,
      damping: 18,
      staggerChildren: 0.18,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 30, scale: 0.97 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 80,
      damping: 16,
    },
  },
  whileHover: {
    scale: 1.04,
    boxShadow: "0 12px 32px rgba(220,38,38,0.18)",
    transition: { type: "spring", stiffness: 200, damping: 12 },
  },
  whileTap: {
    scale: 0.98,
    transition: { type: "spring", stiffness: 300, damping: 18 },
  },
};

const breadcrumbVariants = {
  hidden: { opacity: 0, y: -20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

function AccountingAdvisory() {

// รายการบริการ
  const services = [
    {
      title: "บริการตรวจสอบงบการเงิน",
      desc: "เราให้บริการตรวจสอบงบการเงินที่มีคุณภาพสูง เพื่อให้มั่นใจว่าข้อมูลทางการเงินของคุณถูกต้องและเชื่อถือได้",
      img: require("../../../image/services/statement-audit.webp"),
    },
    {
      title: "บริการสอบทานงบการเงิน",
      desc: "การสอบทานงบการเงินเป็นกระบวนการที่สำคัญในการตรวจสอบความถูกต้องและความน่าเชื่อถือของข้อมูลทางการเงินขององค์กร",
      img: require("../../../image/services/statement-review.webp"),
    },
    {
      title: "บริการตรวจสอบการซื้อกิจการ (Due Diligence)",
      desc: "ตัดสินใจลงทุนอย่างมั่นใจ ลดความเสี่ยงที่ไม่คาดคิด ด้วยข้อมูลเชิงลึกรอบด้าน",
      img: require("../../../image/services/due-diligence.webp"),
    },
    {
      title: "บริการตรวจสอบพิเศษ (Special Audit)",
      desc: "การตรวจสอบเพื่อวัตถุประสงค์พิเศษเป็นเครื่องมือสำคัญในการประเมินความเสี่ยงและความน่าเชื่อถือของข้อมูลทางการเงินและการดำเนินงานขององค์กร",
      img: require("../../../image/services/special-audit.webp"),
    },
    {
      title: "บริการที่ปรึกษาบัญชี และ บริการที่เกี่ยวเนื่อง",
      desc: "เราให้บริการที่ปรึกษาด้านบัญชีและบริการที่เกี่ยวเนื่อง เพื่อช่วยให้ธุรกิจของคุณดำเนินงานได้อย่างมีประสิทธิภาพและสอดคล้องกับมาตรฐานบัญชี",
      img: require("../../../image/services/accounting-advisory.webp"),
    },
  ];

  // สุ่มเลือก 3 รายการ โดยไม่รวมบริการของหน้าปัจจุบัน
  function getRandomServices(arr, n, excludeTitle) {
    const filtered = arr.filter((s) => s.title !== excludeTitle);
    const shuffled = filtered.slice().sort(() => 0.5 - Math.random());
    return shuffled.slice(0, n);
  }
  const randomServices = getRandomServices(services, 3, "บริการที่ปรึกษาบัญชี และ บริการที่เกี่ยวเนื่อง");

  return (
    <div
      style={{
        background: "#f8f9fa",
        minHeight: "100vh",
        paddingTop: 0,
        paddingBottom: 48,
        fontFamily: "Prompt, sans-serif",
      }}
    >
      <section
        className="hero-section"
        style={{
          fontFamily: "Prompt, sans-serif",
          background: `linear-gradient(rgba(30, 30, 30, 0.2), rgba(30,30,30,0.2)), url(${require('../../../image/services/accounting-advisory.webp')}) center center/cover no-repeat`,
        }}
      >
        <div className="hero-content">
          <h1
            className="hero-title"
            style={{ marginTop: "80px", color: "rgba(255, 75, 75, 1)" }}
          >
            {" "}
            บริการที่ปรึกษาบัญชี<br/> และบริการที่เกี่ยวเนื่อง
          </h1>
          <p
            className="hero-subtitle"
            style={{ color: "rgba(255, 255, 255, 1)" }}
          >
            เราให้บริการที่ปรึกษาด้านบัญชีและบริการที่เกี่ยวเนื่อง เพื่อช่วยให้ธุรกิจของคุณดำเนินงานได้อย่างมีประสิทธิภาพและสอดคล้องกับมาตรฐานบัญชี
          </p>
        </div>
      </section>
      {/* Breadcrumbs Section - Red Tone */}
      <Container fluid="md" style={{ marginTop: 0 }}>
        <Row className="justify-content-center">
          <Col xs={120} md={110} lg={100} xl={90} xxl={80}>
            <motion.nav
              aria-label="breadcrumb"
              variants={breadcrumbVariants}
              initial="hidden"
              animate="visible"
              style={{ marginBottom: 0 }}
            >
              <ol
                className="breadcrumb"
                style={{
                  background: "rgba(255, 255, 255, 1)",
                  borderRadius: 14,
                  padding: "12px 24px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  gap: 8,
                  fontSize: 16,
                  fontWeight: 500,
                  marginBottom: 0,
                  alignItems: "center",
                  flexWrap: "wrap",
                  border: "1px solid #ffffffff",
                }}
              >
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff", x: 2 }}
                  whileTap={{ scale: 0.97, color: "#db3b3b" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/"
                    style={{
                      color: "#848484ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 18 }}></span>
                    หน้าแรก
                  </a>
                </motion.li>
                <span
                  style={{ color: "#848484ff", fontSize: 20, margin: "0 4px" }}
                >
                  ›
                </span>
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff", x: 2 }}
                  whileTap={{ scale: 0.97, color: "#db3b3b" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/services"
                    style={{
                      color: "#848484ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 20 }}></span>
                    บริการของเรา
                  </a>
                </motion.li>
                <span
                  style={{ color: "#ffb3b3", fontSize: 18, margin: "0 4px" }}
                >
                  ›
                </span>
                <motion.li
                  className="breadcrumb-item"
                  whileHover={{ scale: 1.08, color: "#848484ff", x: 2 }}
                  whileTap={{ scale: 0.97, color: "#db3b3b" }}
                  style={{ transition: "0.2s", marginRight: 4 }}
                >
                  <a
                    href="/services"
                    style={{
                      color: "#ff7070ff",
                      textDecoration: "none",
                      fontWeight: 600,
                    }}
                  >
                    <span style={{ marginRight: 4, fontSize: 20 }}></span>
                    ที่ปรึกษาบัญชีและบริการที่เกี่ยวเนื่อง
                  </a>
                </motion.li>
              </ol>
            </motion.nav>
          </Col>
        </Row>
      </Container>
      <Container fluid="md">
        <Row className="justify-content-center" style={{ marginTop: 24 }}>
          <Col xs={120} md={110} lg={100} xl={90} xxl={80}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
            >
              <Card
                className="border-0 shadow-sm"
                style={{ borderRadius: 18, background: "#fff" }}
              >
                <Card.Body style={{ padding: 40, marginBottom: 32 }}>
                  <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ type: "spring", stiffness: 80, damping: 18, delay: 0.2 }}
                    className="d-flex align-items-center mb-3"
                  >
                    <FaGavel className="me-2" color=" #db3b3bff" size={28} />
                    <h2
                      className="fw-bold mb-0"
                      style={{ fontSize: 28, letterSpacing: 0.5 }}
                    >
                      บริการที่ปรึกษาบัญชี และบริการที่เกี่ยวเนื่อง
                    </h2>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ type: "spring", stiffness: 70, damping: 16, delay: 0.4 }}
                    className="mb-4"
                    style={{
                      background: "#f3f4f6",
                      borderRadius: 12,
                      padding: 20,
                      marginBottom: 32,
                    }}
                  >
                    <blockquote
                      className="mb-0"
                      style={{
                        fontSize: 16,
                        color: "#555",
                        fontStyle: "italic",
                        borderLeft: "4px solid #db3b3bff",
                        paddingLeft: 16,
                      }}
                    >
                      "นำทางความท้าทายด้านบัญชีและการเงิน ด้วยคำแนะนำจากผู้เชี่ยวชาญ"
                    </blockquote>
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ type: "spring", stiffness: 60, damping: 18, delay: 0.6 }}
                    className="mb-4"
                    style={{ fontSize: 17, color: "#222", lineHeight: 1.7 }}
                  >
                    โลกของมาตรฐานการรายงานทางการเงินมีการเปลี่ยนแปลงและซับซ้อนขึ้นอย่างต่อเนื่อง การมีที่ปรึกษาที่เชี่ยวชาญคอยให้คำแนะนำจะช่วยให้องค์กรของคุณสามารถปรับตัวและปฏิบัติตามมาตรฐานใหม่ๆ ได้อย่างถูกต้องและทันท่วงที นอกจากนี้ เรายังให้บริการที่เกี่ยวเนื่องอื่นๆ เพื่อสนับสนุนการทำงานของฝ่ายบัญชีและการเงินให้มีประสิทธิภาพสูงสุด
                  </motion.p>
                  <hr className="my-4" style={{ opacity: 0.15 }} />
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ type: "spring", stiffness: 70, damping: 16, delay: 0.7 }}
                    className="mb-4"
                  >
                    <h4
                      className="fw-semibold mb-4 d-flex align-items-center"
                      style={{ color: "#db3b3bff", fontSize: 20 }}
                    >
                      <span className="me-2" role="img" aria-label="service">
                        📝
                      </span>{" "}
                      ขอบเขตการบริการของเรา
                    </h4>

                    {/* Service Item 1 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          1
                        </span>
                        ที่ปรึกษาด้านมาตรฐานการรายงานทางการเงิน (TFRS Advisory)
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <li className="mb-2">
                          ให้คำแนะนำในการประยุกต์ใช้มาตรฐานการรายงานทางการเงินฉบับใหม่ๆ หรือฉบับที่มีความซับซ้อน
                        </li>
                        <li className="mb-2">
                          ช่วยประเมินผลกระทบของการเปลี่ยนแปลงมาตรฐานฯ ที่มีต่องบการเงินของบริษัท
                        </li>
                      </ul>
                    </div>

                    {/* Service Item 2 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          2
                        </span>
                        บริการจัดทำงบการเงินรวม (Consolidation Services)
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <p className="mb-0">
                          สำหรับบริษัทที่มีบริษัทย่อย เราให้บริการจัดทำงบการเงินรวมที่ถูกต้องตามมาตรฐานฯ
                        </p>
                      </ul>
                    </div>

                    {/* Service Item 3 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          3
                        </span>
                        บริการจัดทำบัญชีสินทรัพย์ (Fixed Asset Management)
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                       <p className="mb-0">
                          ช่วยจัดทำทะเบียนสินทรัพย์, คำนวณค่าเสื่อมราคา, และให้คำแนะนำในการตรวจนับสินทรัพย์ประจำปี
                        </p>

                      </ul>
                    </div>

                    {/* Service Item 4 */}
                    <div
                      className="mb-4"
                      style={{
                        background:
                          "linear-gradient(135deg, #fff5f5 0%, #fef2f2 100%)",
                        borderRadius: 8,
                        padding: 24,
                        border: "1px solid #ffffffff",
                        boxShadow: "0 4px 12px rgba(255, 255, 255, 0.08)",
                      }}
                    >
                      <h5
                        className="fw-bold mb-3 d-flex align-items-center"
                        style={{ color: "#dc2626", fontSize: 18 }}
                      >
                        <span
                          className="me-2"
                          style={{
                            background: "#dc2626",
                            color: "white",
                            borderRadius: "50%",
                            width: 28,
                            height: 28,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 14,
                            fontWeight: 700,
                          }}
                        >
                          4
                        </span>
                        การปรับปรุงระบบบัญชี
                      </h5>
                      <ul
                        className="mb-0"
                        style={{ paddingLeft: 20, color: "#374151" }}
                      >
                        <p className="mb-0">
                          ให้คำปรึกษาเพื่อพัฒนากระบวนการทำงานและระบบควบคุมภายในของฝ่ายบัญชีให้มีประสิทธิภาพยิ่งขึ้น
                        </p>

                      </ul>
                    </div>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ type: "spring", stiffness: 70, damping: 16, delay: 0 }}
                    className="mb-4"
                  >
                    <h4
                      className="fw-semibold mb-3 d-flex align-items-center"
                      style={{
                        color: "#db3b3bff",
                        fontSize: 24,
                        marginTop: 48,
                      }}
                    >
                      <span className="me-2" role="img" aria-label="price">
                        💸
                      </span>{" "}
                      ทำไมต้องเลือกบริการกฎหมายธุรกิจจากเรา?
                    </h4>
                    <ListGroup variant="flush">
                      <ListGroup.Item
                        style={{
                          background: "none",
                          border: 0,
                          paddingLeft: 0,
                          color: "#444",
                        }}
                      >
                        <span className="fw-bold"></span>
                      </ListGroup.Item>
                      <ListGroup.Item
                        style={{
                          background: "none",
                          border: 0,
                          paddingLeft: 0,
                          color: "#444",
                        }}
                      >
                        เราทำหน้าที่เป็น "ทีมสนับสนุน" ของคุณ ช่วยแก้ปัญหาทางบัญชีที่ซับซ้อนซึ่งทีมงานภายในอาจไม่มีเวลาหรือความเชี่ยวชาญเฉพาะทาง เราให้คำแนะนำที่ชัดเจนและนำไปปฏิบัติได้จริง ช่วยลดความเสี่ยงจากการปฏิบัติที่ไม่ถูกต้องและเพิ่มประสิทธิภาพให้กับการทำงานขององค์กร
                      </ListGroup.Item>
                    </ListGroup>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0 }}
                  >
                    <hr
                      style={{
                        border: "none",
                        borderTop: "2px solid #e0e0e0",
                        margin: "32px 0 24px 0",
                        marginBottom: "32px",
                        opacity: 0.7,
                      }}
                    />
                    <h4
                      className="fw-semibold mb-3 d-flex align-items-center"
                      style={{ color: "#db3b3bff", fontSize: 20 }}
                    >
                      <span className="me-2" role="img" aria-label="related">
                        🔗
                      </span>{" "}
                      บริการอื่นๆ
                    </h4>
                    <motion.div
                      variants={containerVariants}
                      initial="hidden"
                      animate="visible"
                    >
                      <Row xs={1} md={3} className="g-3">
                        {randomServices.map((service, idx) => {
                          let link = "#";
                          switch (service.title) {
                            case "บริการตรวจสอบงบการเงิน":
                              link = "/services/statement-audit";
                              break;
                            case "บริการสอบทานงบการเงิน":
                              link = "/services/statement-review";
                              break;
                            case "บริการตรวจสอบการซื้อกิจการ (Due Diligence)":
                              link = "/services/due-diligence";
                              break;
                            case "บริการตรวจสอบพิเศษ (Special Audit)":
                              link = "/services/special-audit";
                              break;
                            case "บริการที่ปรึกษาบัญชี และ บริการที่เกี่ยวเนื่อง":
                              link = "/services/accounting-advisory";
                              break;
                            default:
                              link = "#";
                          }
                          return (
                            <Col key={idx}>
                              <a href={link} style={{ textDecoration: "none" }}>
                                <motion.div
                                  variants={cardVariants}
                                  whileHover="whileHover"
                                  whileTap="whileTap"
                                  initial="hidden"
                                  animate="visible"
                                  style={{ height: "100%" }}
                                >
                                  <Card
                                    className="h-100 shadow-sm card-hover"
                                    style={{
                                      borderRadius: 18,
                                      background: `linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(220,38,38,0.08) 100%), url(${service.img}) center center/cover no-repeat`,
                                      border: "none",
                                      minHeight: 240,
                                      color: "#fff",
                                      position: "relative",
                                      boxShadow: "0 6px 24px rgba(220,38,38,0.10)",
                                    }}
                                  >
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        background: "rgba(98, 98, 98, 0.5)",
                                        borderRadius: 18,
                                        zIndex: 1,
                                      }}
                                    ></div>
                                    <Card.Body
                                      style={{
                                        position: "relative",
                                        zIndex: 2,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100%",
                                      }}
                                    >
                                      <Card.Title
                                        style={{
                                          color: "#ec3e3eff",
                                          fontWeight: 700,
                                          fontSize: 20,
                                          textAlign: "center",
                                          marginBottom: 12,
                                          letterSpacing: 0.5,
                                          textShadow:
                                            "0 2px 8px rgba(220,38,38,0.08)",
                                        }}
                                      >
                                        {service.title
                                          .split("\n")
                                          .map((line, idx) => (
                                            <React.Fragment key={idx}>
                                              {line}
                                              <br />
                                            </React.Fragment>
                                          ))}
                                      </Card.Title>
                                      <Card.Text
                                        style={{
                                          color: "#dcdcdcff",
                                          fontSize: 16,
                                          textAlign: "center",
                                          fontWeight: 500,
                                          lineHeight: 1.6,
                                        }}
                                      >
                                        {service.desc}
                                      </Card.Text>
                                    </Card.Body>
                                  </Card>
                                </motion.div>
                              </a>
                            </Col>
                          );
                        })}
                      </Row>
                    </motion.div>
                  </motion.div>
                </Card.Body>
              </Card>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AccountingAdvisory;
